import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentVisibilityService {
  private showHeaderFooter = new BehaviorSubject<boolean>(true);
  
  // Observable that components can subscribe to
  public showHeaderFooter$: Observable<boolean> = this.showHeaderFooter.asObservable();
  
  constructor() { }
  
  // Method to hide header and footer
  hideHeaderFooter(): void {
    this.showHeaderFooter.next(false);
  }
  
  // Method to show header and footer
  displayHeaderFooter(): void {
    this.showHeaderFooter.next(true);
  }
  
  // Method to check if header and footer should be hidden
  isUserHeaderFooterHide(): boolean {
    return !this.showHeaderFooter.getValue();
  }
} 